<template>
<el-checkbox-group
  v-model="checkList"
  >
  <el-checkbox
    v-for="(item ,index) in list"
    :key="index"
    :label="item"
    @change="onChange(item, index, $event)"
    >
  </el-checkbox>
</el-checkbox-group>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'checkOne',
  },
  props: {
    list: {
      type: Array,
      default: ['a', 'b', 'c']
    },
    checked: {
      type: Object,
      default: {
        label: 'checkboxName',
        index: 0,
      }
    }
  },
  data() {
    return {
      checkList: [],
    };
  },
  methods: {
    onChange(label, index, eventValue) {
      this.checkList = [label]
      this.$emit('checkOne', {label, index})
    }
  }
};
</script>

<style lang="stylus" scoped>
// .checkbox-item {
//   display: inline-block;
//   padding-top: 0.2rem;
// }

</style>



// WEBPACK FOOTER //
// src/components/widgets/CheckboxGroup.vue